export default __webpack_public_path__ + "static/media/flag.689bce56.svg";